import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Container,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    TextField,
    Button,
    Box,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useCart } from '../../contexts/CartContext';

const Cart: React.FC = () => {
    const { items, removeItem, updateQuantity } = useCart();
    const navigate = useNavigate();

    const handleQuantityChange = (id: string, newQuantity: string) => {
        const quantity = parseInt(newQuantity, 10);
        if (quantity > 0) {
            updateQuantity(id, quantity);
        }
    };

    const total = items.reduce((sum, item) => sum + item.price * item.quantity, 0);

    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <Typography variant="h4" component="h1" gutterBottom>
                Panier
            </Typography>
            {items.length === 0 ? (
                <Box sx={{ textAlign: 'center', py: 4 }}>
                    <Typography variant="h6" gutterBottom>
                        Votre panier est vide
                    </Typography>
                    <Button
                        variant="contained"
                        onClick={() => navigate('/categories')}
                    >
                        Voir les activités
                    </Button>
                </Box>
            ) : (
                <>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Produit</TableCell>
                                    <TableCell align="right">Prix</TableCell>
                                    <TableCell align="right">Quantité</TableCell>
                                    <TableCell align="right">Total</TableCell>
                                    <TableCell align="right">Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {items.map((item) => (
                                    <TableRow key={item.id}>
                                        <TableCell>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                {item.imageUrl && (
                                                    <Box
                                                        component="img"
                                                        src={item.imageUrl}
                                                        alt={item.name}
                                                        sx={{
                                                            width: 60,
                                                            height: 60,
                                                            objectFit: 'cover',
                                                            mr: 2,
                                                        }}
                                                    />
                                                )}
                                                <Typography>{item.name}</Typography>
                                            </Box>
                                        </TableCell>
                                        <TableCell align="right">
                                            {item.price}€
                                        </TableCell>
                                        <TableCell align="right">
                                            <TextField
                                                type="number"
                                                value={item.quantity}
                                                onChange={(e) =>
                                                    handleQuantityChange(item.id, e.target.value)
                                                }
                                                inputProps={{ min: 1 }}
                                                size="small"
                                                sx={{ width: 80 }}
                                            />
                                        </TableCell>
                                        <TableCell align="right">
                                            {item.price * item.quantity}€
                                        </TableCell>
                                        <TableCell align="right">
                                            <IconButton
                                                color="error"
                                                onClick={() => removeItem(item.id)}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Box sx={{ mt: 4, display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography variant="h6" sx={{ mr: 2 }}>
                            Total: {total}€
                        </Typography>
                        <Button
                            variant="contained"
                            onClick={() => navigate('/payment')}
                        >
                            Procéder au paiement
                        </Button>
                    </Box>
                </>
            )}
        </Container>
    );
};

export default Cart;